<template>
  <ProductShowcase
    v-if="similarEvents?.length"
    data-test-id="similar-events"
    class="my-20"
    :gtm-item-list-id="GtmItemListId.EventPageSimilarClasses"
    :products="similarEvents.slice(0, 8)"
    :loading="pending"
    :tags="[]"
    :title="getTitleBySpecialization"
    :title-level="2"
    :use-h-tag="true"
    :algolia-insights-client="insightsClient"
    algolia-insights-label="Similar Events - Event Page"
  />
</template>
<script setup lang="ts">
import { GtmItemListId } from '~/composables/useKftGtm/types'
import type { EventDescription } from '~/composables/types/event'

const eventData = inject<EventDescription>('eventData')
const { client: insightsClient } = useAlgoliaSearchInsights()

const { isGiftcard } = defineProps<{
  isGiftcard: boolean
}>()

const { t } = useI18n()

const getTitleBySpecialization = computed(() => {
  if (isGiftcard) {
    return t('product.giftcardSimilarEvents')
  }

  const specialization = eventData?.specialization

  if (specialization) {
    switch (specialization) {
      case 'COURSE':
        return t('product.similarCourseEvents')
      case 'TOUR':
        return t('product.similarTourEvents')
      case 'EXPERIENCE':
        return t('product.similarExperienceEvents')

      default:
        return t('product.similarEvents')
    }
  }

  return t('product.similarEvents')
})

const { data: similarEvents, pending } = useFetchSimilarEvents(
  eventGetters.getPermalink(eventData),
  eventGetters.getSupplierId(eventData),
  {
    server: false,
    transform: transformToAlgoliaEvent,
    default: () => [],
  }
)
</script>
